import {ListItem} from "@domain/common/list-view/list-item";

/**
 * Énumération des types d'erreur carte
 */
export enum EtatCarte {
    SUCCESS = 0,
    BAD_CONTRAT_REFERENCE = 1,
    BAD_CODE_COLLAB = 2,
    CARTE_DIVERGE_CONTRAT = 3,
    BAD_CARTE_REFERENCE = 4,
    BAD_MEDOC_REFERENCE = 5,
    BAD_MCC_REFERENCE = 6,
    DOUBLON = 10,
    ERREUR = 12,
    BAD_SENS_ECRITURE = 13,
    BAD_PAYS_REFERENCE = 14,
    RETRAIT_DE = 15
}

/**
 * DTO représentant une opération carte en erreur
 */
export class OpeLogError implements ListItem {
    idOpeCarte: string;
    numCarteClair: string;
    erreur: EtatCarte;
    libelleErreur: string;
    libelleSolution: string;
    collab: string;
    matricule?: string;
    montant: number;
    devise: string;
    numContrat: string;
    libelleMedoc: string;
    libelleMcc: string;

    isDisplayed?: boolean;
    isSelected?: boolean;

    getKey(): string {
        return this.idOpeCarte;
    }
}